import type { ApiTourStop } from '#api/tourservice/model/types.ts';
import type { Stop, StopType } from '#domain/model/Stop.ts';
import type { StopStatus } from '#domain/model/StopStatus.ts';

import { mapLocation } from './locationAdapter.ts';

const mapStopType = (stop: ApiTourStop): StopType => {
    if (stop.load && stop.load.length > 0) {
        return 'load';
    }
    if (stop.unload && stop.unload.length > 0) {
        return 'unload';
    }
    if (stop.execute && stop.execute.length > 0) {
        return 'service';
    }
    return 'unknown';
};

const mapStopStatus = (stop: ApiTourStop): StopStatus => {
    if (stop.finished_at) {
        return 'finished';
    }
    if (stop.reached_at) {
        return 'reached';
    }
    return 'open';
};

const getTransportOrderIds = (stop: ApiTourStop, stopType: StopType) => {
    switch (stopType) {
        case 'load':
            return stop.load ?? [];
        case 'unload':
            return stop.unload ?? [];
        default:
            return [];
    }
};

export const mapStop = (stop: ApiTourStop): Stop => {
    const stopType = mapStopType(stop);
    return {
        id: stop.id,
        name: stop.location.name ?? '',
        startActual: stop.reached_at,
        startTarget: stop.planned_arrival_at,
        endActual: stop.finished_at,
        endTarget: stop.planned_departure_at,
        location: mapLocation(stop.location),
        type: stopType,
        status: mapStopStatus(stop),
        comment: undefined,
        latitude: `${stop.location.coordinates.latitude}`,
        longitude: `${stop.location.coordinates.longitude}`,
        transportOrderIds: getTransportOrderIds(stop, stopType),
        serviceOrderIds: stop.execute ?? [],
    };
};

export const mapStops = (stops: ApiTourStop[]): Stop[] => stops.map(mapStop);
